import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ItemFamilia } from '../item-familia';

@Injectable({
    providedIn: 'root'
})
export class ItemFamiliaCrudHttpService implements Crud<ItemFamilia> {
    resource = 'itemfamilia';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os itens familias cadastrados */
    search(): Observable<ItemFamilia[]> {
        return this.crudService.search<ItemFamilia>(this.resource);
    }

    /** Procura um único item familia através do seu ID */
    find(id: number): Observable<ItemFamilia> {
        return this.crudService.find<ItemFamilia>(this.resource, id);
    }

    /** Carrega um único item familia através do seu ID */
    load(id: number): Observable<ItemFamilia> {
        return this.crudService.load<ItemFamilia>(this.resource, id);
    }

    /** Insere um novo item familia */
    insert(entity: ItemFamilia): Observable<ItemFamilia> {
        return this.crudService.insert<ItemFamilia>(this.resource, entity);
    }

    /** Altera um item familia existente */
    update(entity: ItemFamilia): Observable<ItemFamilia> {
        return this.crudService.update<ItemFamilia>(this.resource, entity);
    }

    /** Exclui um item familia através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
